// extracted by mini-css-extract-plugin
export default {"claimLayoutNameField":"ClaimLayoutNameField_claimLayoutNameField__Ygt5c"};